// eslint-disable-next-line no-unused-vars
import React from 'react'
import Gallery from './Gallery'

export default Gallery
